import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ParametroPorItem } from "app/types/Parametro"
import { resetAll } from "./actions/resetAll"

const initialState: ParametroPorItem[] = []

export const parametrosPorItemSlice = createSlice({
    name: "parametrosPorItem",
    initialState,
    extraReducers: builder => builder.addCase(resetAll, () => initialState),
    reducers: {
        inserirOuAtualizar: (state, action: PayloadAction<ParametroPorItem>) => {
            const { Nome, oidItem } = action.payload
            const index = state.findIndex(p => 
                p.Nome === Nome && p.oidItem === oidItem
            )
            
            if (index >= 0) {
                state[index] = action.payload
            } else {
                state.push(action.payload)
            }
        },
        remover: (state, action: PayloadAction<{Nome: string, oidItem: number}>) => {
            const { Nome, oidItem } = action.payload
            const index = state.findIndex(p => 
                p.Nome === Nome && p.oidItem === oidItem
            )
            
            if (index >= 0) {
                state.splice(index, 1)
            }
        }
    }
})

export default parametrosPorItemSlice.reducer
export const { inserirOuAtualizar, remover } = parametrosPorItemSlice.actions